import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-white pt-8 md:pt-20 pb-10 md:pb-20 px-4" data-id="element-57">
      <div className="max-w-4xl mx-auto text-center" data-id="element-58">
        <h1 className="font-heading text-[24px] leading-[1.15] md:text-5xl lg:text-[56px] text-headline font-extrabold md:leading-[1.1] mb-3 md:mb-5 tracking-tight max-w-3xl mx-auto" data-id="element-59">
          Trasforma il tuo Studio di Pilates con il Bundle Italia Élite.
        </h1>

        <p className="text-body text-sm md:text-lg mb-6 md:mb-10 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-60">
          6 Manuali Tecnici + 5 Bonus Esclusivi. Smetti di pianificare a
          mezzanotte e inizia a insegnare come un Master Trainer.
        </p>

        <div className="relative max-w-[280px] md:max-w-md mx-auto mb-6 md:mb-10" data-id="element-61">
          <img src="https://cdn.magicpatterns.com/uploads/j4z1ZdcGhshyy3o2b1wcxP/Diseno_sin_titulo_(24).png" alt="Pilates Italia Elite Bundle — 11 prodotti digitali" className="w-full h-auto" data-id="element-62" />
        </div>

        <div className="mb-4 md:mb-6" data-id="element-63">
          <CTAButton className="text-base md:text-xl py-4 md:py-5 px-8 md:px-14" data-id="element-64">
            SÌ, VOGLIO ACCEDERE ORA (€67)
          </CTAButton>
        </div>

        <p className="text-[10px] md:text-xs text-body/50 font-medium flex justify-center items-center gap-2 md:gap-4" data-id="element-65">
          <span data-id="element-66">⚡ Download immediato</span>
          <span className="text-body/20" data-id="element-67">|</span>
          <span data-id="element-68">📱 Consulta dal telefono</span>
          <span className="text-body/20" data-id="element-69">|</span>
          <span data-id="element-70">🔒 Garanzia 14 giorni</span>
        </p>
      </div>
    </section>;
}